import styled from "styled-components";
import Line from "../Line";
import { CButton } from "@carrefour/design-system-components-react";
import { Communication } from "../../types/Communication";
import { checkAndFormatDate } from "../../utils/dateUtils";
import { useTranslation } from "react-i18next";


const StyledInput = styled.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;

  &[type="date"]:not(.has-value) {
    color: transparent;
    caret-color: transparent;
    &::-webkit-datetime-edit { color: transparent; }
  }
  &[type="date"].has-value {
    color: inherit;
  }
`;

const TransparentInput = styled.div`
  width: 100%;
  border: none;
  background: transparent;
  pointer-events: none;
  padding: 8px 0;
  box-sizing: border-box;
  text-align: left;
  white-space: normal;
  @media (min-width: 769px) {
    width: auto;
  }
`;

const BorderedInput = styled(StyledInput)`
  width: 150px;
  border: 1px solid #656565;
  pointer-events: none;
`;

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

const ListLabel = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  margin-left: 0;
  align-self: flex-start;
  display: flex;
`;

const ListContainer = styled.div`
  width: 98%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  overflow-y: auto;
  @media (min-width: 768px) {
    width: 550px;
  }
`;

const ListItem = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
`;

const ListItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
  gap: 0.4rem;
  margin-left: 0.3rem;
`;

const Footer = styled.div`
  margin-top: auto;
  text-align: center;
  width: 100%;
  
  @media (min-width: 769px) {
    text-align: right;
  }
`;

const CustButton = styled.button`
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  font-size: 1rem;
  padding: 0;
  margin-top: 1rem;
  
  @media (min-width: 769px) {
    margin-left: 2rem;
  }
  &:hover {
    text-decoration: underline;
  }
`;

const StyledLabel = styled.label`
  display: block;
  font-size: 0.850rem;
  font-weight: 500;
  margin-bottom: 4px;
  text-align: left;
  strong {
    font-size: 0.75rem;
  }
`;

const CommunicationList = ({
  communications,
  loading,
  showDetail,
  onNew,
  onClose,
}: {
  communications: Communication[];
  loading: boolean;
  showDetail: (comm: Communication) => void;
  onNew: () => void;
  onClose: () => void;
}) => {

  const {t} = useTranslation();

  return (
    <>
      <Title>{t('communication.manag_communications')}</Title>
      <br />
      <ListContainer>
        <ListLabel>{t('communication.list_communications')}</ListLabel>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <StyledLabel>{t('communication.msg_refreshing')}</StyledLabel>
          </div>
        ) : !communications || communications.length === 0 ? (
          <div style={{ textAlign: "center" }}>
            <StyledLabel>{t('communication.msg_nodata')}</StyledLabel>
          </div>
        ) : (
          communications.map((comm) => (
            <ListItemWrapper key={comm.id}>
              <ListItem onClick={() => showDetail(comm)}>
                <TransparentInput>{comm.title}</TransparentInput>
                <BorderedInput
                  type="text"
                  value={
                    checkAndFormatDate(comm.startDate) +
                    " au " +
                    checkAndFormatDate(comm.endDate)
                  }
                  disabled
                />
                <CButton variation="tertiary" size="m" appendIcon="chevron-right" />
              </ListItem>
              <Line />
            </ListItemWrapper>
          ))
        )}
        <br />
        <CButton key="new" onClick={onNew} size="s" variation="secondary">
                    {t('communication.add_communiation')} 
        </CButton>
      </ListContainer>

      <Footer>
        <Line />
        <CustButton onClick={onClose}>{t('communication.cancel')}</CustButton>
      </Footer>
    </>
  );
};

export default CommunicationList;